import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { createdMonthDayYear } from '../../../commonservice';
import cn from 'classnames';
import './PostCarouselPopup.scss';

interface PostCarouselPopupProps {
  show: boolean;
  handleClose: () => void;
  post: any;
}

const PostCarouselPopup: React.FC<PostCarouselPopupProps> = ({ show, handleClose, post }) => {
  if (!post) return null;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="PostCarouselPopup"
      size="lg"
    >
      <Modal.Header closeButton>
        <div className="post-header">
          <div className="user-info">
            {post?.createdBy?.image ? (
              <img src={post.createdBy.image} alt={post.createdBy.name} className="user-avatar" />
            ) : (
              <div className="user-avatar-placeholder">
                {post?.createdBy?.name?.charAt(0)}
              </div>
            )}
            <div className="user-details">
              <div className="user-name">{post?.createdBy?.name}</div>
              <div className="post-date">
                <i className="fa fa-calendar"></i>
                {createdMonthDayYear(post?.createdAt)}
              </div>
            </div>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="post-content">
          {(post?.title 
          // || post?.caption // TODO: Uncomment this when we have captions
        ) && (
            <h2 className="post-caption">{post?.title 
              // || post?.caption // TODO: Uncomment this when we have captions
              }</h2>
          )}
          
          {post?.medias?.length > 0 && (
            <div className="media-section">
              <div className={cn('media-grid', {
                'single-media': post.medias.length === 1,
                'two-media': post.medias.length === 2,
                'three-media': post.medias.length === 3,
                'four-media': post.medias.length === 4,
              })}>
                {post.medias.map((media: any, index: number) => (
                  <div key={index} className="media-item">
                    {media.type === 'video' ? (
                      <div className="video-container">
                        <video 
                          src={media.url} 
                          controls
                          poster={media.thumbnail}
                        />
                        <div className="play-icon">
                          <i className="fa fa-play"></i>
                        </div>
                      </div>
                    ) : (
                      <img src={media.url} alt={`Media ${index + 1}`} />
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {post?.description && (
            <div className="post-description">
              {post.description}
            </div>
          )}

          <div className="post-actions">
            <button className="action-button share">
              <i className="fa fa-share"></i>
              <span>Share</span>
            </button>
          </div>

          {post?.comments?.length > 0 && (
            <div className="comments-section">
              <h3>Comments</h3>
              <div className="comments-list">
                {post.comments.map((comment: any, index: number) => (
                  <div key={index} className="comment-item">
                    <div className="comment-user">
                      {comment.createdBy?.image ? (
                        <img src={comment.createdBy.image} alt={comment.createdBy.name} />
                      ) : (
                        <div className="user-avatar-placeholder">
                          {comment.createdBy?.name?.charAt(0)}
                        </div>
                      )}
                      <div className="comment-content">
                        <div className="comment-user-name">{comment.createdBy?.name}</div>
                        <div className="comment-text">{comment.text}</div>
                        <div className="comment-date">{createdMonthDayYear(comment.createdAt)}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PostCarouselPopup; 